// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconMap = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M23.46 5.26L16.51.25c-.22-.16-.48-.24-.74-.25h-.04c-.26 0-.52.08-.74.24L8.26 5.09 2.08.63C1.68.34 1.15.3.71.53.27.76 0 1.22 0 1.72v15.94c0 .43.2.83.55 1.08l6.95 5.01c.22.16.48.24.74.24h.04c.26 0 .52-.08.74-.24l6.72-4.85 6.18 4.46c.41.29.93.33 1.37.1.44-.23.71-.68.71-1.18V6.34c.01-.43-.2-.83-.54-1.08zM9.05 6.47l5.92-4.27v15.33L9.05 21.8V6.47zM1.56 2.2l5.92 4.27V21.8l-5.92-4.27V2.2zm20.88 19.6l-5.92-4.27V2.2l5.92 4.27V21.8z"
      fill="currentColor"
    />
  );
export default SvgIconMap;
